// extracted by mini-css-extract-plugin
export default {"root":"RowActionsMenu_root__it7bD","trigger":"RowActionsMenu_trigger__XYidU IconButton_root__GKLaF","quiet":"RowActionsMenu_quiet__7QplG","content":"RowActionsMenu_content__w3sN4"};